<template>
    <div class="d-flex flex-column">
        <div class="my-auto text-center" v-if="onLoading && !mounted">
                <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Caricamento...</span>
        </div>
        <div class="d-flex h-100 flex-column" v-if="mounted">
            <div class="d-flex justify-content-between align-items-center alert alert-danger" v-if="error && (specializzazione || studio || prestazione)">
                <i class="far fa-frown fa-3x mr-4"></i>
                <div class="w-100">
                    <p class="mb-0">Qualcosa è andato storto</p>
                    <a :href="clinica.url">Ricarica la pagina</a>
                </div>
            </div>
            <div v-else-if="error">
                <div id="stepper-container" class="highlight">
                    <p class="lead text-center mb-0">
                        <i class="fas fa-exclamation-circle text-warning fa-3x d-block mb-3" aria-hidden="true"></i>
                        Il centro medico non è attualmente disponibile per la prenotazione online
                    </p>
                </div>
            </div>
            <template v-else>
            <div class="row" v-if="existVisitaTipoVideoconsulto">
                <div class="col-12 bg-gray-100" id="clinica-videoconsulto-tabber">
                    <ul class="nav nav-tabs">
                        <li class="nav-item" v-if="existVisitaTipoStudio">
                            <a class="nav-link" :class="{'active': currentTipoVisita != 3}" href="javascript:;" @click="setTipoVisita(1)"><i class="fas fa-hospital-alt fa-fw"></i> Visita in studio</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active': currentTipoVisita == 3}" href="javascript:;" @click="setTipoVisita(3)"><i class="fas fa-video fa-fw"></i> Videoconsulto</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- stepper -->
            <div id="stepper-container">
                <div class="idoc-vertical-stepper">
                    <div class="step" :class="{'active': currentStep >= 1}">
                        <div class="step-header">
                            <div class="step-counter" data-step="1"></div>
                            <div class="step-progress"></div>
                        </div>
                        <div class="step-content">
                            <label>Specializzazione</label>
                            <select class="form-control" v-model="idSpecializzazione" @change="selectSpecializzazione">
                                <option v-for="s in specializzazioni" :value="s.ID" :key="'specs' + s.ID">
                                    {{ s.nome }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="step" :class="{'active': currentStep >= 2}">
                        <div class="step-header">
                            <div class="step-counter" data-step="2"></div>
                            <div class="step-progress"></div>
                        </div>
                        <div class="step-content">
                            <template v-if="currentTipoVisita == 3">
                                <label>Online</label>
                            </template>
                            <template v-else>
                                <label>{{ sedi && sedi.length == 1 ? 'Sede' : 'Scegli la Sede' }}</label>
                                <template v-if="idSpecializzazione && (!onLoading || idSede)">
                                    <div class="form-group mb-0">
                                        <div class="form-check py-1" v-collapsible="showAllStudi" :class="[s.ID == idSede ? 'font-weight-bold d-block' : '', k >= num_studi_visibili && s.ID != idSede ? 'collapse' : 'not-collapsed', sedi.length == 1 ? 'pl-0': '' ]" v-for="(s, k) in sedi" :key="k">
                                            <label class="form-check-label d-flex justify-content-between align-items-center">
                                                <span>
                                                    <input type="radio" v-model="idSede" :value="s.ID" :class="{'d-none': sedi.length == 1}" class="form-check-input" @change="setSede">
                                                        <span :class="{'ml-2': sedi.length > 1}" v-html="s.labelStudioDisponibilita"></span>
                                                        <span v-if="s.inpromozione" title="Sconti prevenzione">
                                                            <img src="/images/frontend/percentuale.svg" alt="Sconti prevenzione">
                                                        </span>
                                                </span>
                                                <button v-if="s.ID == idSede && (s.tipo == 1 || s.parcheggio || s.modalita_pagamento)" data-toggle="modal" data-target="#detailStudioModal-real" type="button" class="btn btn-link text-muted btn-sm p-0 text-decoration-underline"><small><i class="fas fa-exclamation-circle" aria-hidden="true"></i> Dettagli</small></button>
                                            </label>
                                        </div>
                                        <button v-if="sedi.length > num_studi_visibili" class="btn btn-link btn-sm p-0 text-decoration-underline mt-2 mt-lg-0" @click="showAllStudi = !showAllStudi">
                                            <span v-if="!showAllStudi">Vedi</span><span v-if="showAllStudi">Nascondi</span> altri studi
                                        </button>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>

                    <div class="step" :class="{'active': currentStep >= 3}">
                        <div class="step-header">
                            <div class="step-counter" data-step="3"></div>
                            <div class="step-progress"></div>
                        </div>
                        <div class="step-content">
                            <div>
                                <label>Prestazione</label>
                                <template v-if="!disabledSceltaPrestazione && prestazioni.length > 1">
                                    <a role="button" class="rfs-6 float-right btn btn-link p-0 small" @click="openPrestazioniModal">
                                        {{ idPrestazione ? 'Modifica' : 'Seleziona' }}
                                    </a>
                                </template>
                            </div>
                            <template v-if="!disabledSceltaPrestazione">
                                <div v-if="idPrestazione" class="d-flex flex-column">
                                    <div class="d-flex justify-content-between">
                                        <div class="w-100">
                                            {{ currentPrestazione.scorciaNome }}
                                            <!-- <span v-if="keyword">
                                                <small class="d-block">
                                                    per <b>{{ keyword.keyword | ucfirst }}</b>
                                                </small>
                                            </span> -->
                                        </div>
                                        <div class="w-auto text-nowrap rfs-8">{{ prezzoPrestazione }}</div>
                                    </div>
                                    <div class="d-flex justify-content-between text-promo mt-2" v-if="existPromotion">
                                        <div class="w-100">
                                            Scontato dal <span class="text-capitalize">{{ existPromotion.datainizio | mydate('DD MMM') }}</span> al <span class="text-capitalize">{{ existPromotion.datafine | mydate('DD MMM YY') }}</span>
                                        </div>
                                        <div class="w-auto text-nowrap">{{ prezzoPrestazionePromo }}</div>
                                    </div>
                                    <div v-if="mostraPagamentoAnticipato && prezzoPagamentoOnline && currentStudioMedicoSelected">
                                        <p class="d-flex justify-content-between text-muted small">
                                            <i class="fas fa-credit-card mt-1" data-toggle="tooltip" data-placement="top" :title="'Possibilità di pagare in anticipo con carta di credito, a tariffa agevolata di ' + prezzoPagamentoOnline  + ' €'" aria-hidden="true"></i>
                                            <span class="w-100 ml-2">
                                                Risparmia il {{ currentStudioMedicoSelected.pagamento_anticipato_sconto }}% pagando online
                                                <span class="d-block small">
                                                    (Scegli <em>"Paga in anticipo con carta"</em> alla conferma)
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div v-if="warningPrestazione" class="d-flex justify-content-between">
                                    <div class="alert alert-warning small mb-0 mt-2 px-2 w-100">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ warningPrestazioneCutted }}<template v-if="showMore">{{ warningPrestazioneSecondHalf }}</template> <a role="button" href="javascript:;" v-if="warningPrestazioneReadMoreText" @click="toggleReadMore()">{{ warningPrestazioneReadMoreText }}</a>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="step" :class="{'active': currentStep >= 4}">
                        <div class="step-header">
                            <div class="step-counter" data-step="4"></div>
                            <div class="step-progress"></div>
                        </div>
                        <div class="step-content">
                            <label>Medico</label>
                            <template v-if="idPrestazione && medici.length">
                                <select v-if="medici.length > 1" id="medici-struttura-select" class="form-control mt-n2" v-model="idMedico" @change="requestDisponibilita()">
                                    <option v-for="m in medici" :value="m.ID" :key="m.ID" :data-imagesrc="m.foto" :data-description="m.specializzazione_principale">
                                        {{ m.fullName }}
                                    </option>
                                </select>
                                <div v-else>
                                    {{ medici[0].fullName }}
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="step" :class="{'active': currentStep >= 5}">
                        <div class="step-header">
                            <div class="step-counter" data-step="5"></div>
                        </div>
                        <div class="step-content onlylabel" :class="{'text-black-50 ' : !listDisp.length}">
                            <label :class="{'gray-scale strike-text' : !listDisp.length && idMedico && !onLoading }">Scegli giorno e ora</label>
                        </div>
                    </div>
                </div>
                <!-- stepper -->
                <!-- orari -->
                <div>
                    <template v-if="listDisp.length || choosing">
                        <Calendario
                            class="my-3"
                            ref="cal"
                            :disponibilita="listDisp"
                            :cols="cols"
                            :showloader="false"
                            :visibleHoursBeforeHide="8"
                            :promozioni="promozioni"
                        />
                    </template>
                    <template v-else-if="(idMedico || medici.length == 1) && richiedibile">
                        <RichiediDisponibilita
                            :id-medico="(idMedico ? idMedico : medici[0].ID)"
                            :id-clinica="idClinica"
                            class="mt-3"
                        />
                        <div class="text-secondary small mt-2">
                            sarai ricontattato dalla segreteria per concordare un appuntamento
                        </div>
                    </template>
                    <template v-else-if="medici.length > 0">
                        <div class="w-100 mt-4 text-center border-top py-4">
                            {{ medico.preposizioneIl }} <strong>{{ medico.fullName }}</strong> non è disponibile per la prenotazione online.
                        </div>
                    </template>
                    <template v-else>
                        <div class="w-100 mt-4 text-center border-top py-4">
                            Nessun medico disponibile per la prenotazione online.
                        </div>
                    </template>
                </div>
            </div>
            </template>

            <!-- /orari -->

            <div class="modal fade" v-if="idSede" id="detailStudioModal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title" v-html="'Info su ' + (currentSede.tipo == 1 ? 'studio a ' : '') + '<strong>' + currentSede.labelStudioTitle + '</strong>'"></h5>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-4" v-if="currentSede.tipo == 2">
                                <span class="d-block">
                                    {{ currentSede.presso2 }}
                                </span>
                            </div>
                            <div class="mb-4" v-if="currentSede.tipo == 1">
                                <p class="lead mb-2"><small class="fas fa-location-arrow" aria-hidden="true"></small> Indirizzo</p>
                                <span class="d-block">
                                    {{ currentSede.via }}
                                    <a :href="'https://www.google.it/maps/place/' + currentSede.latitudine + ',' + currentSede.longitudine" class="btn btn-info btn-sm ml-2" target="_blank" rel="nofollow noopener">
                                        <i class="fas fa-map" aria-hidden="true"></i> Vedi mappa
                                    </a>
                                </span>
                            </div>

                            <div class="mb-4" v-if="currentSede.parcheggio">
                                <p class="lead mb-2"><i class="fas fa-car" aria-hidden="true"></i> Dove parcheggiare?</p>
                                <span class="d-block">
                                    {{ currentSede.parcheggioLabel }}
                                </span>
                            </div>

                            <div class="mb-4" v-if="currentSede.pagamentiLabel && currentSede.pagamentiLabel.length">
                                <p class="lead mb-2"><i class="fas fa-money-bill" aria-hidden="true"></i>  Modalità di pagamento</p>
                                <ul>
                                    <li v-for="(m, k) in currentSede.pagamentiLabel" :key="k">{{ m.value }}</li>
                                </ul>
                            </div>

                            <div class="mb-4" v-if="currentSede.tipo == 1">
                                <p class="lead mb-2"><i class="fas fa-wheelchair" aria-hidden="true"></i>  Accessibilità</p>
                                {{ currentSede.accessibilitaLabel }}
                            </div>
                        </div>
                        <div class="modal-footer justify-content-end">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modalPrestazioni modal-body-fixed" v-if="idSede" id="modalPrestazioni" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            Scelta della prestazione
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body p-0">
                            <div class="p-2 bg-gray-200" v-if="listPrestazioniFilteredMostBooked.length">
                                <h4 class="mb-0">Prestazioni più prenotate</h4>
                            </div>
                            <div class="d-flex justify-content-between align-items-center border-top p-2 pl-3" :onclick="'window.appListe.$refs.BoxDispClinica.selectPrestazioneId(' + p.ID + ')'" v-for="(p, k) in listPrestazioniFilteredMostBooked" :key="k+'-most'">
                                <p class="mb-0">
                                    {{ p.nome }}
                                </p>
                                <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                    {{ p.testo_da + p.prezzo_da }} €
                                </button>
                            </div>
                            <div class="p-2 bg-gray-200 sticky-top mr-0">
                                <h4 class="mb-0">Tutte le prestazioni</h4>
                            </div>
                            <div id="allPrestMedico">
                                <div class="d-flex justify-content-between align-items-center border p-2 pl-3" :onclick="'window.appListe.$refs.BoxDispClinica.selectPrestazioneId(' + p.ID + ')'" v-for="(p, k) in prestazioni" :key="k+'-all'">
                                    <p class="mb-0">
                                        {{ p.nome }}
                                    </p>
                                    <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                        {{ p.testo_da + p.prezzo_da }} €
                                    </button>
                                </div>
                            </div>

                            <template v-if="existVideoconsultoFilter">
                                <div class="p-2 bg-gray-200 text-center">
                                    <h3 class="mb-0"><i class="fas fa-video" aria-hidden="true"></i> Videoconsulti</h3>
                                </div>
                                <div class="d-flex justify-content-between align-items-center border p-2" :onclick="'window.appListe.$refs.BoxDispClinica.selectPrestazioneId(' + p.ID + ')'" v-for="(p, k) in listPrestazioniFilteredVideoconsulti" :key="k+'-video'">
                                    <p class="mb-0">
                                        {{ p.nome }}
                                    </p>
                                    <button type="button" style="max-width:90px" class="btn btn-block btn-primary btn-block text-nowrap ml-4">
                                        {{ p.testo_da + p.prezzo_da }} €
                                    </button>
                                </div>
                            </template>
                        </div>
                        <div class="modal-footer justify-content-end">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Calendario from "./Calendario";
import RichiediDisponibilita from "./RichiediDisponibilita";
export default {
    components: {
        Calendario,
        RichiediDisponibilita
    },
    props: {
        idClinica: null,
        specializzazione: null,
        studio: null, //non è lo studio, in realtà la sede della clinica che è l'id_parent negli studi medici
        prestazione: null,
    },
    data: function () {
        return {
            existVisitaTipoStudio: false,
            existVisitaTipoVideoconsulto: false,
            currentTipoVisita: 1,
            mounted: false,
            onLoading: false,
            specializzazioni: [],
            prestazioni: [],
            currentPrestazione: null,
            medici: [],
            medico: null,
            error: null,
            clinica: null,
            currentStudioMedicoSelected: null,
            defaultIdMedico: null,
            idSpecializzazione: '',
            idPrestazione: null,
            idSede: null,
            idMedico: null,
            sedi: [],
            listStudi: [],
            showBoxOrari: false,
            filterPrest: 'piu_prenotate',
            showAllStudi: false,
            num_studi_visibili: 2,
            listDisp: [],
            currentDay: null,
            promozioni: [],
            warningPrestazione: null,
            warningPrestazioneCutted: null,
            warningPrestazioneSecondHalf: null,
            warningPrestazioneReadMoreText: null,
            showMore: false,
            warningCarLimit: 155,
            existPromotion: null,
            prezzoPagamentoOnline: null,
            mostraPagamentoAnticipato: false,
            richiestaDiretta: false,
            cols: 5,
            richiedibile: false,
        }
    },
    mounted() {
        this.idPrestazione = this.prestazione;
        this.idSede = this.studio;
        this.idSpecializzazione = this.specializzazione;

        window.addEventListener('resize', () => {
            //distinct between mobile, tablet and desktop
            if (window.innerWidth < 420) {
                this.cols = 3;
            }
            else if (window.innerWidth < 576) {
                this.cols = 5;
            }
            else if (window.innerWidth < 992) {
                this.cols = 6;
            } else {
                this.cols = 5;
            }
        });

        //call resize
        window.dispatchEvent(new Event('resize'));

        this.requestDisponibilita();
    },
    watch: {
    },
    computed: {
        choosing: function() {
            return this.onLoading || !this.idSpecializzazione || !this.idSede || (this.medici.length > 1 && !this.idMedico);
        },
        currentStep: function() {
            if (!this.idSpecializzazione) {
                return 0;
            }

            if (!this.idSede) {
                return 1;
            }

            if (!this.idPrestazione) {
                return 2;
            }

            return 4;
        },
        disabledSceltaPrestazione() {
            if (this.sedi.length  == 1) {
                return this.idSpecializzazione ? false : true;
            } else {
                return (this.idSpecializzazione == null || this.idSpecializzazione == '') || this.idSede == null;
            }
        },
        currentSede() {
            if (!this.idSede) {
                return null;
            }
            return this.sedi.find(s => s.ID == this.idSede);
        },
        prezzoPrestazione: function() {
            if (!this.idPrestazione) return null;

            const prest = this.prestazioni.find(p => p.ID == this.idPrestazione);
            if (!prest) return null;

            let prezzo = prest.prezzo_da ? prest.prezzo_da : 'GRATIS';

            return prest.testo_da + prezzo + ' €';
        },

        prezzoPrestazionePromo: function() {
            if (!this.existPromotion) return null;
            return this.existPromotion.prestazioni[0].prezzoscontato + ' €';
        },
        currentDisponibilita: function() {
            if (!this.listDisp.length) return [];

            const disp = this.listDisp.find(d => d.giorno == this.currentDay);
            if (!disp) return [];
            return disp.listOrari;
        },
        existVideoconsultoFilter: function() {
            return this.prestazioni.find(p => p.is_videoconsulto) ? true : false;
        },

        listPrestazioniFilteredMostBooked: function() {
            return this.prestazioni.filter(p => p.mostBooked).sort((a, b) => a.ID > b.ID ? 1 : -1);
        },
        listPrestazioniFilteredVideoconsulti: function() {
            return this.prestazioni.filter(p => p.is_videoconsulto);
        },
    },
    methods: {
        setTipoVisita(tipo) {
            this.currentTipoVisita = tipo;
            this.idSpecializzazione = '';
            this.idSede = null;
            this.idPrestazione = null;
            this.idMedico = null;
            this.showBoxOrari = false;
            this.sedi = [];
            this.medici = [];
            this.prestazioni = [];
            this.listDisp = [];
            this.currentPrestazione = null;
            this.requestDisponibilita();
        },
        openPrestazioniModal() {
            $('#modalPrestazioni-real').modal('show');
        },
        setSpecializzazione(id) {
            //chiamata da fuori per impostare la specializzazione
            this.idSpecializzazione = id;
            this.selectSpecializzazione();
        },
        setSede() {
            this.idPrestazione = null;
            this.idMedico = null;
            this.medici = [];
            this.requestDisponibilita();
        },
        setMedico(id, spec) {
            //chiamata da fuori per impostare il medico
            this.currentTipoVisita = 1;
            if (spec == 73) {
                this.currentTipoVisita = 3;
            } else {
                this.idSpecializzazione = spec;
            }
            this.idMedico = id;

            this.idPrestazione = null; //la resettiamo, ci pensa il controller a prendere la più prenotata
            this.idSede = null; //resetto anche questa, ci pensa il controller a prendere la prima
            this.sedi = [];
            this.requestDisponibilita();
        },
        selectSpecializzazione() {
            //Se riparto dalla selezione della specializzazione, resetto i campi
            this.idSede = null;
            this.idPrestazione = null;
            this.idMedico = null;
            this.showBoxOrari = false;
            this.sedi = [];
            this.medici = [];
            this.requestDisponibilita();
        },
        selectPrestazione(p) {
            this.medici = [];
            this.idPrestazione = p.ID;
            $('#modalPrestazioni-real').modal('hide');
            this.requestDisponibilita();
        },
        selectPrestazioneId(k) {
            let p = this.prestazioni.find(p => p.ID == k);
            this.selectPrestazione(p);
        },
        triggerPrenotaCliniche() {
            setTimeout(() => {
                $('#stepper-container').trigger('click');
            }, 1);
        },
        existStudioPromotion: function() {
            if (!this.promozioni.length || !this.idSede || !this.idPrestazione) {
                return false;
            }

            if (this.medici.length > 1 && !this.idMedico) {
                return false;
            }


            if (!this.currentStudioMedicoSelected) return false;

            const existIsValidPromotion =  this.promozioni.filter(c => c.prestazioni.find(p => p.id_studi == this.currentStudioMedicoSelected.ID));
            if (!existIsValidPromotion.length) return false;

            for(const k in this.listDisp) {
                const disp = this.listDisp[k];

                const existPromotion = existIsValidPromotion.find(c => c.datainizio.isSameOrBefore(disp.giorno) && c.datafine.isSameOrAfter(disp.giorno));
                /**
                 * In questo caso sto controllando il corrente, quindi mi salvo in memoria il dato
                 */
                if (existPromotion) {
                    this.existPromotion = existPromotion;
                    this.prezzoPagamentoOnline = this.existPromotion.prestazioni[0].prezzoscontato;
                    return existPromotion;
                }
            }
            return false;
        },
        requestDisponibilita: function() {
            this.onLoading = true;
            this.error = null;

            let formData = {
                idClinica: this.idClinica,
                idMedico: this.idMedico,
                idPrestazione: this.idPrestazione,
                idSpecializzazione: this.idSpecializzazione,
                idSede: this.idSede,
                tipoStudio: this.currentTipoVisita,
                // idKeyword: this.curIdKeyword
            };

            this.listDisp = [];
            $('#medici-struttura-select').ddslick('destroy');

            httpRequest(api_url + 'frontend/clinica/disponibilita', formData, {showLoader: this.mounted}).then(onResult => {

                this.clinica = onResult.data.clinica;
                if (!onResult.result) {
                    this.error = onResult.error;
                }

                /**
                 * Contiene le sole effettive prenotabile e vendono restituite sempre tutte indipendentemente dai filtri applicati
                 */
                this.specializzazioni = onResult.data.specializzazioniClinica;

                this.existVisitaTipoStudio = onResult.data.existVisitaTipoStudio;
                this.existVisitaTipoVideoconsulto = onResult.data.existVisitaTipoVideoconsulto;

                /**
                 * Primo arrivo, l'utente deve selezionare cosa vuole fare
                 */
                if (onResult.data.selezionaSpecializzazione) {
                    return;
                }

                /**
                 * L'endpoint ha determinato da solo qual'è la specializzazione da utilizzare in quanto c'è ne solo una disponibile, ma qui la devo settare!
                 * oppure arrivo dalle liste e si è posizionato su specializzazione videoconsulto
                 */
                if (!this.idSpecializzazione || this.idSpecializzazione == Idoc.VIDEOCONSULTO_PRESTAZIONE_ID) {
                    /**
                     * Index 1 perchè mi arriva a modi select e 0 è il default di selezione
                     */
                    this.idSpecializzazione = this.specializzazioni[1].ID;
                }

                this.sedi = onResult.data.sediClinica;

                /**
                 * Seleziono la sede obbligatorio in quanto per l'accoppiata prevista, esistono più sedi
                 */
                if (onResult.data.selezionaSede) {
                    return;
                }

                /**
                 * Solo se non è selezionta, in quanto l'endpoint restituisce sempre tutte le sedi per la specializzazione!
                 */
                if (!this.idSede) {
                    this.idSede = this.sedi[0].ID;
                }

                this.currentTipoVisita = this.sedi[0].tipo == 3 ? 3 : 1;

                // this.disponibile = onResult.data.disponibile;

                this.medici = onResult.data.medici;
                this.medico = onResult.data.medico;

                this.defaultIdMedico = null;
                if (this.idSede && (this.medici.length == 1 || this.idMedico)) {
                    this.defaultIdMedico = this.idMedico ? this.idMedico : this.medici[0].ID;
                }

                this.listStudi = onResult.data.listStudi;

                this.currentStudioMedicoSelected = null;
                if (this.idSede && this.defaultIdMedico) {
                    this.currentStudioMedicoSelected = this.listStudi.find(s => s.id_parent == this.idSede && s.ID_medico == this.defaultIdMedico);
                }

                // this.keyword = onResult.data.keyword;
                this.listDisp = onResult.data.listDisp || [];

                if (this.medici.length > 1) {
                    this.medici = [{
                        ID: null,
                        fullName: this.listDisp.length ? 'Qualsiasi specialista' : 'Seleziona un medico',
                        foto: this.listDisp.length ? '/immagine-medico/70x70c1q95/no_foto_dottore.jpg' : null,
                        specializzazione_principale: ' '
                    }].concat(this.medici);
                }

                this.idPrestazione = onResult.data.prestazione.ID;
                this.prestazioni = onResult.data.prestazioniClinica;
                this.currentPrestazione = onResult.data.prestazione;
                this.mostraPagamentoAnticipato = onResult.data.mostraPagamentoAnticipato;

                this.prezzoPagamentoOnline = onResult.data.prezzoPagamentoOnline;

                this.currentDay = this.listDisp.length ?  this.listDisp[0].giorno : null;

                this.existPromotion = null;

                this.promozioni = [];

                if (this.currentStudioMedicoSelected) {
                    this.promozioni = onResult.data.promozioni.filter(promozione => {
                        return promozione.prestazioni.some(prestazione => prestazione.id_studi == this.currentStudioMedicoSelected.ID);
                    });
                }

                if (this.promozioni.length) {
                    for(const k in this.promozioni) {
                        this.promozioni[k].datainizio = moment(this.promozioni[k].datainizio);
                        this.promozioni[k].datafine = moment(this.promozioni[k].datafine);
                    }
                }

                /**
                 * issue, le modal non possono stare in un parent con position stiky
                 * https://stackoverflow.com/questions/43452005/bootstrap-modal-wont-display-if-the-position-of-its-parent-container-set-to-fix
                 */
                $('#detailStudioModal-real').remove();
                $('#modalPrestazioni-real').remove();
                setTimeout(() => {
                    $('#detailStudioModal').clone().appendTo('body').attr('id', 'detailStudioModal-real');
                    $('#modalPrestazioni').clone().appendTo('body').attr('id', 'modalPrestazioni-real');
                }, 200);


                this.existStudioPromotion();
                this.showBoxOrari = true;

                this.warningPrestazione = onResult.data.warningPrestazione;
                this.warningPrestazioneCutted = this.warningPrestazione;
                this.warningPrestazioneSecondHalf = null;
                this.warningPrestazioneReadMoreText = null;
                this.showMore = false;

                this.richiestaDiretta = authToken ? true : false;

                this.richiedibile = onResult.data.medico.medicoRichiedibile;

                if (this.warningPrestazioneCutted.length > this.warningCarLimit && !onResult.data.doNotCutWarning) {
                    this.warningPrestazioneCutted = this.warningPrestazioneCutted.substring(0, this.warningCarLimit);
                    this.warningPrestazioneSecondHalf = this.warningPrestazione.substring(this.warningCarLimit);
                    this.warningPrestazioneReadMoreText = '[...continua]';
                }


            }).finally(() => {
                this.mounted = true;
                this.onLoading = false;
                if(this.medici.length > 1) {
                    setTimeout(() => {
                        $('#medici-struttura-select').ddslick({
                            onSelected: (data) => {
                                const id = data.selectedData.value;
                                this.idMedico = id;
                                this.requestDisponibilita();
                            },
                            background: '#fff',
                            width: '100%',
                            height: 'auto',
                        });
                    }, 200);

                }
                $('#stepper-container').trigger('click');
            });

        },
        toggleReadMore: function() {
            this.showMore = !this.showMore;
            this.warningPrestazioneReadMoreText = this.showMore ? '[...meno]' : '[...continua]';
        },
    },
}
</script>

<style lang="scss" scoped>
    $stepper-steps: 5;
    $stepper-circle-size: 1.1rem;
    $stepper-content-height: 6rem;
    $stepper-background: #b8b8b9;
    $stepper-color: #fff;
    $stepper-active-background: #4caf50;
    $stepper-active-color: var(--white);

    #stepper-container {
        z-index:1041;
    }

    .idoc-vertical-stepper{
        width:100%;
        margin: 0 auto;
        padding-bottom:0;
        .step {
            display: flex;
            margin-bottom: 5px;
            height: fit-content;
            .step-counter {
                display:flex;
                font-size: .75rem;
                &:after {
                    flex: 1;
                    align-self: center;
                    font-size: .7rem;
                }
            }
            &:not(.active) .step-header .step-counter {
                &:after {
                    content: attr(data-step);
                }
            }
            &.active .step-header {
                .step-progress {
                    background-color: $stepper-active-background;
                }
                .step-counter {
                    background-color: $stepper-active-background;
                    color: $stepper-active-color;
                    &:after {
                        content: "\f00c";
                        font-family: "Font Awesome 5 Free";
                        font-weight: 600;
                        font-size: .5em;
                    }
                }
            }
            .step-header{
                justify-content: space-between;
                overflow: hidden;
                padding-top:2px;
                .step-counter {
                    width: $stepper-circle-size;
                    height: $stepper-circle-size;
                    border-radius: 50%;
                    background-color: $stepper-background;
                    color: $stepper-color;
                    text-align: center;
                }
                .step-progress {
                    width: 1px;
                    background-color: $stepper-background;
                    margin: auto;
                    height: 100%;
                    margin-top: 5px;
                    margin-bottom: 5px;
                }
            }
            .step-content {
                flex: 1;
                padding-bottom: 10px;
                padding-left: 10px;
                margin-top:-1px;
                &.onlylabel {
                    margin-bottom:-20px;
                    padding-bottom:0;
                }
            }
        }
        label {
            font-weight: bold;
            margin-bottom: 0;
        }
    }

    .content.onlylabel {
        min-height:fit-content !important;
        height:fit-content !important;
    }
    .day-box.disabled {
        cursor: default !important;
    }
    .day-hours .btn-secondary.disabled {
        background-color: #eaeced;
        border-color: #ccc;
    }
</style>
<style lang="scss">
.page-clinica {
    .dd-select {
        border:none !important;
        border-radius: 0.25rem;
    }
    .dd-options {
        max-height: 510px;
        overflow-y: scroll;
    }
    .dd-option-image, .dd-selected-image {
        width: 100%;
        max-width: 45px !important;
        height: 100%;
        object-fit: cover;
        aspect-ratio: 1/1;
        border-radius: 50%;
    }
    .dd-selected {
        background: #fff !important;
        border:1px solid #ced4da !important;
        border-radius: 0.25rem !important;
    }
    .dd-pointer-down, .dd-pointer-up {
        border:none !important;
        right:15px !important;
        top: 40% !important;
        color: #495057;
    }
    .dd-pointer-up {
        visibility:hidden;
        top:45% !important;
    }
    .dd-pointer-down:after {
        font-family: "Font Awesome 5 Free";
        content: "\f078";
        font-size: 10px;
        font-weight: 600;
        color: #495057;
        -webkit-text-stroke: .1px #495057;
    }
    .dd-pointer-down.dd-pointer-up:after {
        content: "\f077";
        visibility: visible;
        right:15px !important;
        top:40% !important;
    }
    .dd-option {
        padding: 1rem 2rem !important;
    }
    .dd-options {
        border-top: none !important;
    }
    .dd-selected-text, .dd-option-text {
        margin-bottom: .1rem !important;
        line-height: fit-content !important;
    }
    .dd-desc {
        min-height:1.4em;
    }
    @media (max-width: 500px) {
        @media (max-height: 480px) {
            .dd-options {
                max-height: 320px;
            }
        }
        @media (min-height:481px) and (max-height: 560px) {
            .dd-options {
                max-height: 400px;
            }
        }
        @media (min-height: 561px) and (max-height: 999px) {
            .dd-options {
                max-height: 460px;
            }
        }
    }

}
</style>
